// extracted by mini-css-extract-plugin
export default {"ac-project--secondary":"ac-project-card_ac-project--secondary__aJ1k3","ac-project--tertiary":"ac-project-card_ac-project--tertiary__OeBZF"};